import { Left, Right, storageApiRoutes } from './index.js';
export async function uploadFile(api, incomingFile, uploadType, onProgress) {
    onProgress?.('Preparing', 1);
    const [sessionStartError, sessionStart] = await api(storageApiRoutes, 'file/upload-start', {
        data: {
            uploadType,
            file: {
                clientName: incomingFile.name,
                headers: { 'content-type': incomingFile.type },
                size: incomingFile.size,
            },
        },
    });
    if (sessionStartError || !sessionStart) {
        console.error('Failed to start upload session', sessionStartError);
        return Left(sessionStartError.error.code);
    }
    const chunkSize = 5 * 1024 * 1024; // 5MB in bytes
    const totalChunks = Math.ceil(incomingFile.size / chunkSize);
    const uploadedParts = [];
    onProgress?.('Uploading', 1);
    for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, incomingFile.size);
        // Read and convert the current chunk to base64
        const chunkBlob = incomingFile.slice(start, end);
        const arrayBuffer = await chunkBlob.arrayBuffer();
        const chunk = arrayBufferToBase64(arrayBuffer);
        // Upload the chunk
        const [chunkErr, chunkRes] = await api(storageApiRoutes, 'file/upload-chunk', {
            data: {
                sessionId: sessionStart.data.sessionId,
                key: sessionStart.data.key,
                partNumber: i + 1,
                totalParts: totalChunks,
                partData: chunk,
            },
        });
        if (chunkErr || !chunkRes) {
            console.error('Failed to upload chunk ' + (i + 1), chunkErr);
            return Left(chunkErr.error.code);
        }
        uploadedParts.push(chunkRes.data);
        onProgress?.('Uploading', Math.floor(((i + 1) / totalChunks) * 100));
    }
    onProgress?.('Completing', 99);
    const [completeErr, result] = await api(storageApiRoutes, 'file/upload-complete', {
        data: {
            sessionId: sessionStart.data.sessionId,
            key: sessionStart.data.key,
            parts: uploadedParts,
        },
    });
    if (completeErr || !result) {
        console.error('Failed to complete upload session', completeErr);
        return Left(completeErr.error.code);
    }
    return Right(result.data);
}
// Helper function to convert ArrayBuffer to base64
function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
uploadFile.unwrap = async function (api, incomingFile, uploadType, onProgress) {
    const [error, value] = await uploadFile(api, incomingFile, uploadType, onProgress);
    if (error)
        throw error;
    return value;
};
//# sourceMappingURL=upload-file.js.map